import { pdkAxios } from '@/lib/pdk-axios';
import type { SMSAgentMessage } from '@/models/registry';
import { useMutation } from '@tanstack/react-query';

type SendSMSParams = {
  text: string;
  dealId: string;
};

const useSendSMSMutation = ({
  // shortId,
  onSuccess,
  onError,
}: {
  // shortId: Deal['short_id'] | null | undefined;
  onSuccess?: (data: SMSAgentMessage, variables: SendSMSParams) => void;
  onError?: (error: Error, variables: SendSMSParams) => void;
}) => {
  // const queryClient = useQueryClient();

  const sendSMSMutation = useMutation({
    // onMutate: async ({ text, dealId }: SendSMSParams) => {
    //   if (!dealId || !shortId) {
    //     throw new Error('Deal ID or short ID is required');
    //   }

    //   // Create optimistic message
    //   const optimisticMessage = {
    //     id: uuidv4(),
    //     deal_id: dealId,
    //     message_id: Date.now(), // temporary ID
    //     message_date: new Date().toISOString(),
    //     direction: 'outbound' as const,
    //     to_number: '', // will be filled by server
    //     from_number: '', // will be filled by server
    //     text,
    //     mms: false,
    //     mms_url: null,
    //   };

    //   // Add to store optimistically
    //   smsAgentMessageStore.add(optimisticMessage);

    //   return { optimisticMessage };
    // },
    mutationFn: async ({ text, dealId }: SendSMSParams) => {
      const response = await pdkAxios
        .post(`/deals/${dealId}/send-sms`, {
          text,
        })
        .catch((e) => {
          console.error('Error sending SMS', e);
          throw e;
        });

      return response.data;
    },
    onSuccess: (
      data,
      variables,
      // context
    ) => {
      // Replace optimistic message with real one
      // if (context?.optimisticMessage) {
      //   smsAgentMessageStore.replace(data);
      // }
      onSuccess?.(data, variables);
    },
    onError: (
      error,
      variables,
      //  context
    ) => {
      // Remove optimistic message on error
      // if (context?.optimisticMessage) {
      //   smsAgentMessageStore.store.delete(context.optimisticMessage.id);

      //   // Also remove from foreign key index
      //   const messages =
      //     smsAgentMessageStore.storeIndexedByForeignKey.get(variables.dealId) ||
      //     [];
      //   const filteredMessages = messages.filter(
      //     (m) => m.id !== context.optimisticMessage.id,
      //   );
      //   smsAgentMessageStore.storeIndexedByForeignKey.set(
      //     variables.dealId,
      //     filteredMessages,
      //   );
      // }

      onError?.(error, variables);
      console.error('Error sending SMS', error, variables);
    },
    onSettled: () => {
      // queryClient.invalidateQueries({ queryKey: ['deal', shortId] });
    },
  });

  return { sendSMSMutation };
};

export default useSendSMSMutation;
